/*
 * @Author: zhanglei
 * @Date: 2024-10-24 17:22:24
 * @LastEditors: zhanglei
 * @LastEditTime: 2024-10-25 10:44:53
 * @Description: 文章来源检测（根据文章链接来源和url上参数判断走S级文章页）
 */
export default function(opts) {
    const referrer = document.referrer
    const isFromPartySubject = referrer?.indexOf('/subject/325661') > -1 // 来自两会专题的文章
    const isFromOldHtml =
        referrer.indexOf('news.sohu.com/s2017/shijiuda/index.shtml') > -1
    const hasG0param = /\?g=0/gi.test(window.location.href) // 商讯文章页url带g=0
    const isPure = opts.isPure === '1' // 后端写死逻辑：文章标题中包含以下关键字：李鹏、同志、总理、习近平
    const hideAd = opts.hideAd === 'true' // 前端首页服务签名ace字段，文章页服务前面ace字段对比，一致则表示来自pc首页党专区（top-news1）
    const hasCodeParam = /[&|?]code=.+/gi.test(window.location.href)
    if (
        isFromPartySubject ||
        isFromOldHtml ||
        hasG0param ||
        isPure ||
        hideAd ||
        hasCodeParam
    ) {
        return '2' // 代表S级文章页
    }
}